// Mock data for crewmate - breakdance encyclopedia

export const MOVE_TYPES = [
  'toprock',
  'footwork', 
  'powermoves',
  'freezes',
  'transitions',
  'flips'
];

export const DEFAULT_KEYWORD_CATEGORIES = {
  position: ['Front', 'Back', 'Top', 'Bottom', 'Left', 'Right'],
  basics: ['Spin', 'Jump', 'Slide', 'Freeze', 'Repeated', 'Doubled', 'Kicked', 'Otherside', 'Reversed'],
  'hip hop': ['Roll', 'Wave', 'Bounce', 'Pop', 'Rock', 'Groove'],
  space: ['Step', 'Longer', 'Higher', 'Down', 'Circled', 'Slowed', 'Energized', 'Transferred', 'Switched'],
  original: ['Isolated', 'Threaded', 'Grabbed foot', 'Touched foot w/ hand', 'Spidered', 'Hooked', 'Drill'],
  signature: ['Shake knee', '9090', 'Tip toe', 'Royal', 'Thunderbolt']
};

export const MOCK_MOVES = [
  {
    id: '1',
    name: 'Cross Step',
    type: 'toprock',
    isBasic: true,
    videoLink: 'https://youtube.com/example1',
    origin: 'Original breaking foundation',
    description: 'Basic toprock step crossing one leg over the other'
  },
  {
    id: '2', 
    name: 'Indian Step',
    type: 'toprock',
    isBasic: true,
    videoLink: 'https://youtube.com/example2',
    origin: 'Classic breaking move',
    description: 'Rhythmic stepping pattern with arm movements'
  },
  {
    id: '3',
    name: 'Six Step',
    type: 'footwork',
    isBasic: true,
    videoLink: 'https://youtube.com/example3', 
    origin: 'Foundation breaking move',
    description: 'Basic six-count footwork pattern on the ground'
  },
  {
    id: '4',
    name: 'Three Step',
    type: 'footwork',
    isBasic: true,
    videoLink: 'https://youtube.com/example4',
    origin: 'Breaking foundation',
    description: 'Simplified three-count footwork sequence'
  },
  {
    id: '5',
    name: 'Windmill',
    type: 'powermoves',
    isBasic: true,
    videoLink: 'https://youtube.com/example5',
    origin: 'Classic power move from early breaking',
    description: 'Continuous spinning move on back and shoulders'
  },
  {
    id: '6',
    name: 'Headspin',
    type: 'powermoves', 
    isBasic: true,
    videoLink: 'https://youtube.com/example6',
    origin: 'Iconic breaking power move',
    description: 'Spinning on the head with legs in various positions'
  },
  {
    id: '7',
    name: 'Baby Freeze',
    type: 'freezes',
    isBasic: true,
    videoLink: 'https://youtube.com/example7',
    origin: 'Foundation freeze move',
    description: 'Basic freeze position balancing on hands and head'
  },
  {
    id: '8',
    name: 'Chair Freeze',
    type: 'freezes',
    isBasic: true,
    videoLink: 'https://youtube.com/example8', 
    origin: 'Classic breaking freeze',
    description: 'Freeze position resembling sitting in a chair'
  },
  {
    id: '9',
    name: 'Backflip',
    type: 'flips',
    isBasic: true,
    videoLink: 'https://youtube.com/example9',
    origin: 'Gymnastics and breaking fusion',
    description: 'Backward somersault in the air'
  },
  {
    id: '10',
    name: 'Front Flip',
    type: 'flips',
    isBasic: true,
    videoLink: 'https://youtube.com/example10',
    origin: 'Gymnastics and breaking fusion',
    description: 'Forward somersault in the air'
  },
  {
    id: '11',
    name: 'Side Flip',
    type: 'flips',
    isBasic: true,
    videoLink: 'https://youtube.com/example11',
    origin: 'Gymnastics and breaking fusion',
    description: 'Sideways somersault in the air'
  }
];

// Mock user data for personalization
export const MOCK_USER_DATA = {
  id: 'user_1',
  name: 'B-Boy Demo',
  customVariations: { ...DEFAULT_KEYWORD_CATEGORIES },
  createdMoves: [],
  preferences: {
    favoriteTypes: ['toprock', 'footwork'],
    defaultShuffleCount: 1
  }
};

// Helper functions for shuffle logic
export const getAllKeywords = (userVariations = DEFAULT_KEYWORD_CATEGORIES) => {
  return Object.values(userVariations).flat();
};

export const getRandomMove = (moveType = null, userMoves = MOCK_MOVES) => {
  const filteredMoves = moveType 
    ? userMoves.filter(move => move.type === moveType)
    : userMoves;
  return filteredMoves[Math.floor(Math.random() * filteredMoves.length)];
};

export const getRandomKeywords = (count, categories = null, userVariations = DEFAULT_KEYWORD_CATEGORIES) => {
  let availableKeywords = [];
  
  if (categories && categories.length > 0) {
    categories.forEach(category => {
      if (userVariations[category]) {
        availableKeywords = [...availableKeywords, ...userVariations[category]];
      }
    });
  } else {
    availableKeywords = getAllKeywords(userVariations);
  }
  const shuffled = availableKeywords.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

// CSV parsing helper
export const parseCSV = (csvText) => {
  if (typeof csvText !== 'string') {
    console.error('csvText n\'est pas une chaîne !', csvText);
    return [];
  }
  const lines = csvText.trim().split('\n');
  const headers = lines[0].split(',').map(h => String(h).trim());
  return lines.slice(1)
    .filter(line => typeof line === 'string' && String(line).trim() !== '')
    .map((line, index) => {
      const values = String(line).split(',').map(v => String(v).trim());
      const move = {};
      headers.forEach((header, i) => {
        move[header.toLowerCase().replace(/\s+/g, '')] = values[i] || '';
      });
      return {
        id: Date.now() + index,
        name: move.name || 'Unnamed Move',
        type: move.type || 'toprock',
        videoLink: move.videolink || move.video || '',
        origin: move.origin || 'User Import',
        description: move.description || ''
      };
    });
};